import { render } from "./AddColisDistr.vue?vue&type=template&id=b043ccec&ts=true"
import script from "./AddColisDistr.vue?vue&type=script&lang=ts"
export * from "./AddColisDistr.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__